import store from '../store'

export default [
  {
    path: '/clientes/:cliente_id/responsaveis/novo',
    name: 'clientes-responsaveis-create',
    props: true,
    beforeEnter: async (to, from, next) => {
      await store.dispatch('getIndustrias')
      await store.commit('setResponsavelDoCliente', {
        cliente_id: Number(to.params.cliente_id)
      })
      next()
    },
    meta: {
      title: 'Novo responsável do cliente',
      requireAuth: true
    },
    component: function () {
      return import(/* webpackChunkName: "routes" */ '@/views/cliente/responsavel/id')
    }
  },
  {
    path: '/clientes/responsaveis/:id',
    name: 'clientes-responsaveis-update',
    props: true,
    beforeEnter: async (to, from, next) => {
      await store.dispatch('getResponsavelDoCliente', {
        id: Number(to.params.id)
      })
      next()
    },
    meta: {
      title: 'Atualizar responsável',
      routeToEditTelefone: 'responsaveis-update-telefone',
      routeToAddTelefone: 'responsaveis-create-telefone',
      documentAttrTelefone: 'responsavelDoCliente',
      requireAuth: true
    },
    component: function () {
      return import(/* webpackChunkName: "routes" */ '@/views/cliente/responsavel/id')
    }
  }
]
